module.exports = __webpack_public_path__ + "static/boss-eb3cfea74c1b8d567367d36a74b49adb.mp4";